import { useState, useEffect } from "react";
import http from "../utils/axios";

/**
 * Reusable hook for loading filter dropdown data (districts, talukas, categories, sub-categories).
 * Accepts the current district_id and category_id to conditionally load dependent dropdowns.
 */
export const useFilterDropdowns = ({ district_id = "", category_id = "" } = {}) => {
  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [subCategoriesLoading, setSubCategoriesLoading] = useState(false);

  // Load districts and categories on mount
  useEffect(() => {
    http.get("/public/districts").then((res) => {
      setDistricts(res.data || []);
    }).catch(() => setDistricts([]));

    http.get("/public/categories").then((res) => {
      setCategories(res.data || []);
    }).catch(() => setCategories([]));
  }, []);

  // Load talukas when district changes
  useEffect(() => {
    if (district_id) {
      http.get(`/public/districts/${district_id}/talukas`).then((res) => {
        setTalukas(res.data || []);
      }).catch(() => setTalukas([]));
    } else {
      setTalukas([]);
    }
  }, [district_id]);

  // Load sub-categories when category changes
  useEffect(() => {
    if (category_id) {
      setSubCategoriesLoading(true);
      const category = categories.find((c) => c.uuid === category_id);
      if (category?.slug) {
        http.get(`/public/categories/${category.slug}/sub-categories`)
          .then((res) => {
            setSubCategories(res.data || []);
            setSubCategoriesLoading(false);
          })
          .catch(() => {
            setSubCategories([]);
            setSubCategoriesLoading(false);
          });
      } else {
        setSubCategories([]);
        setSubCategoriesLoading(false);
      }
    } else {
      setSubCategories([]);
    }
  }, [category_id, categories]);

  return {
    districts,
    talukas,
    categories,
    subCategories,
    subCategoriesLoading,
  };
};

export default useFilterDropdowns;
